import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { BRAND_LOGO, BRAND_NAME, BRAND_NAME_UPPER, BRAND_YEAR } from '../brand';

const Home = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--page-bg)',
      padding: '20px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Stars decoration */}
      <div style={{ position: 'absolute', top: '20px', left: '30px', fontSize: '40px', color: 'var(--brand-primary)', opacity: '0.8' }}>★</div>
      <div style={{ position: 'absolute', top: '60px', left: '80px', fontSize: '25px', color: 'var(--brand-deep)', opacity: '0.6' }}>★</div>
      <div style={{ position: 'absolute', top: '30px', right: '50px', fontSize: '35px', color: 'var(--brand-deep)', opacity: '0.7' }}>★</div>
      <div style={{ position: 'absolute', top: '80px', right: '100px', fontSize: '20px', color: 'var(--brand-primary)', opacity: '0.5' }}>★</div>

      {/* Décor vague de marque */}
      <div style={{
        position: 'absolute',
        bottom: '0',
        left: '0',
        right: '0',
        height: '8px',
        background: 'linear-gradient(90deg, var(--brand-deep) 0%, var(--brand-deep-light) 50%, var(--brand-primary) 100%)'
      }}></div>

      {/* Main Card */}
      <div style={{
        background: '#ffffff',
        borderRadius: '25px',
        padding: '50px 60px',
        boxShadow: 'var(--shadow)',
        border: '2px solid var(--border)',
        position: 'relative',
        zIndex: '1',
        maxWidth: '500px',
        width: '100%'
      }}>
        {/* Stars on card */}
        <div style={{ position: 'absolute', top: '-18px', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '12px' }}>
          <span style={{ fontSize: '35px', color: 'var(--brand-primary)' }}>★</span>
          <span style={{ fontSize: '35px', color: 'var(--brand-deep)' }}>★</span>
          <span style={{ fontSize: '35px', color: 'var(--brand-primary)' }}>★</span>
        </div>

        {/* Bandeau de marque */}
        <div style={{
          position: 'absolute',
          top: '0',
          left: '0',
          right: '0',
          height: '6px',
          background: 'linear-gradient(90deg, var(--brand-deep) 0%, var(--brand-primary) 100%)',
          borderRadius: '20px 20px 0 0'
        }}></div>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px', marginTop: '20px' }}>
          <img
            src={BRAND_LOGO}
            alt={BRAND_NAME}
            style={{
              width: '150px',
              height: 'auto',
              marginBottom: '20px',
              filter: 'drop-shadow(0 6px 20px rgba(1, 129, 72, 0.5))'
            }}
          />
          <h1 style={{
            color: 'var(--text)',
            fontSize: '36px',
            fontWeight: 'bold',
            margin: '15px 0',
            textTransform: 'uppercase',
            letterSpacing: '3px'
          }}>
            ★ {BRAND_NAME_UPPER} ★
          </h1>
          <p style={{
            color: 'var(--brand-deep)',
            fontSize: '18px',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            letterSpacing: '4px'
          }}>
            CARTE À GRATTER
          </p>
        </div>

        {/* User info */}
        {user && (
          <div style={{
            background: 'linear-gradient(135deg, var(--surface-alt) 0%, #ffffff 100%)',
            borderRadius: '15px',
            padding: '20px 30px',
            marginBottom: '30px',
            border: '3px solid var(--brand-deep)',
            boxShadow: '0 4px 15px rgba(1, 129, 72, 0.15)'
          }}>
            <p style={{ margin: '0', fontSize: '16px', color: 'var(--text)', fontWeight: 'bold' }}>
              Connecté en tant que : <span style={{ color: 'var(--brand-primary)' }}>{user.username}</span>
            </p>
            <p style={{ margin: '5px 0 0', fontSize: '14px', color: 'var(--brand-deep)' }}>
              Rôle : <strong style={{ color: 'var(--text)' }}>{user.role}</strong>
            </p>
          </div>
        )}

        {/* Actions */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          {user?.role === 'super_admin' || user?.role === 'admin' ? (
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                background: 'linear-gradient(180deg, var(--text) 0%, var(--brand-deep) 50%, var(--text) 100%)',
                border: '3px solid var(--brand-deep)',
                borderRadius: '15px',
                padding: '18px 30px',
                color: 'white',
                fontSize: '18px',
                fontWeight: 'bold',
                cursor: 'pointer',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                boxShadow: '0 8px 25px rgba(30, 43, 36, 0.12)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
            >
              ★ DASHBOARD ADMIN ★
            </button>
          ) : user?.role === 'hotesse' ? (
            <button
              onClick={() => navigate('/hostess')}
              style={{
                background: 'linear-gradient(180deg, var(--text) 0%, var(--brand-deep) 50%, var(--text) 100%)',
                border: '3px solid var(--brand-deep)',
                borderRadius: '15px',
                padding: '18px 30px',
                color: 'white',
                fontSize: '18px',
                fontWeight: 'bold',
                cursor: 'pointer',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                boxShadow: '0 8px 25px rgba(30, 43, 36, 0.12)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
            >
              ★ INTERFACE HÔTESSE ★
            </button>
          ) : null}

          <button
            onClick={handleLogout}
            style={{
              background: 'var(--brand-primary)',
              border: 'none',
              borderRadius: '15px',
              padding: '15px 30px',
              color: 'white',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              textTransform: 'uppercase',
              letterSpacing: '2px',
              boxShadow: '0 6px 20px rgba(30, 43, 36, 0.12)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
            onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
          >
            DÉCONNEXION
          </button>
        </div>

        {/* Footer */}
        <div style={{ marginTop: '40px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontSize: '20px', color: 'var(--brand-primary)' }}>★</span>
          <p style={{ color: 'var(--brand-deep)', fontSize: '13px', margin: '0', fontWeight: 'bold' }}>
            © {BRAND_YEAR} {BRAND_NAME_UPPER}.
          </p>
          <span style={{ fontSize: '20px', color: 'var(--brand-primary)' }}>★</span>
        </div>
      </div>
    </div>
  );
};

export default Home;
